<template>
  <div class="poiner" @click.prevent.stop="$emit('goToPreview')">
    <div class="box sb">
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div class="flex-fill line-clamp text-break">
            <slot />
          </div>
        </div>
        <div v-if="editPermission" class="d-flex align-items-start ml-2">
          <c-button
            size="iconic"
            icon="edit"
            :tooltip="{
              text: 'Редактировать',
              activeText: 'Редактировать',
            }"
            @click.prevent.stop="$emit('goToEdit')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button2 from "@/components/controls2/Button";

export default {
  name: "bubble-comment",
  components: {
    "c-button": Button2,
  },
  props: {
    editPermission: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.poiner {
  cursor: pointer;
}

.line-clamp {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  -webkit-box-align: center;
}

.box {
  max-width: 360px;
  border: 1px solid #dfe4ef;
  border-radius: 1rem;
  padding: 10px 10px 10px 20px;
  position: relative;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #333;

  &:before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-left: 6px solid transparent;
    border-right: 6px solid #dfe4ef;
    border-top: 6px solid #dfe4ef;
    border-bottom: 6px solid transparent;
    right: 36px;
    bottom: -12px;
  }

  &:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-left: 6px solid transparent;
    border-right: 6px solid #fff;
    border-top: 6px solid #fff;
    border-bottom: 6px solid transparent;
    right: 37px;
    bottom: -9px;
  }
}
</style>
